import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

import enResources from './translations/en.json';
import itResources from './translations/it.json';
import frResources from './translations/fr.json';
import esResources from './translations/es.json';
import ptResources from './translations/pt.json';
import nlResources from './translations/nl.json';
import fiResources from './translations/fi.json';
import roResources from './translations/ro.json';
import svResources from './translations/sv.json';
import csResources from './translations/cs.json';
import hrResources from './translations/hr.json';
import plResources from './translations/pl.json';
import skResources from './translations/sk.json';
import slResources from './translations/sl.json';

const resources = {
  en: {
    ...enResources,
  },
  it: {
    ...itResources,
  },
  fr: {
    ...frResources,
  },
  es: {
    ...esResources,
  },
  pt: {
    ...ptResources,
  },
  nl: {
    ...nlResources,
  },
  fi: {
    ...fiResources,
  },
  ro: {
    ...roResources,
  },
  sv: {
    ...svResources,
  },
  cs: {
    ...csResources,
  },
  hr: {
    ...hrResources,
  },
  pl: {
    ...plResources,
  },
  sk: {
    ...skResources,
  },
  sl: {
    ...slResources,
  },
};

const TRANSLATIONS_URL = process.env.REACT_APP_TRANSLATIONS_URL || '';
const DYNAMIC_I18N = process.env.REACT_APP_DYNAMIC_I18N === 'true' && !!TRANSLATIONS_URL;
const PREFIX = 'smp-ui';

if (DYNAMIC_I18N) {
  // Bundle ONLY English as the last-resort fallback. Every other language is fetched fresh
  // from CloudFront on demand, so the UI never shows a stale bundled value: during the brief
  // load it shows current language (fallbackLng), then the CloudFront copy. If the fetch fails, English
  // remains and the app keeps working. Lookup order: CloudFront -> English.
  i18n
    .use(HttpBackend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      resources: { en: { ...enResources } },
      // Required so i18next still loads non-bundled languages (nl, fr...) from the backend
      // even though English is provided in `resources`. Without it, the backend is never called.
      partialBundledLanguages: true,
      // Published files use base codes (en, fr...). Strip region so en-US resolves to en.json.
      load: 'languageOnly',
      keySeparator: '.',
      interpolation: { escapeValue: false },
      fallbackLng: 'en',
      // The app has no Suspense boundary: render the English fallback during the async load
      // instead of suspending.
      react: { useSuspense: false },
      backend: {
        loadPath: `${TRANSLATIONS_URL}/${PREFIX}/{{lng}}.json`,
        // Published files are wrapped as { translation: {...} }, but http-backend loads a file
        // as the 'translation' namespace data directly. Unwrap so keys resolve correctly
        // (otherwise everything double-nests and falls back to English).
        parse: (data: string) => {
          const json = JSON.parse(data);
          return json.translation || json;
        },
      },
    });
} else {
  // Static bundled mode (dynamic delivery disabled): original behaviour.
  i18n
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      resources,
      keySeparator: '.',
      interpolation: {
        escapeValue: false,
      },
      fallbackLng: 'en',
    });
}

export default i18n;
